export default __webpack_public_path__ + "static/media/icon-sheet.d3ce26f1.png";